module.exports = __webpack_public_path__ + "static/media/open-eye.90ef59ca.svg";